"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.suggestions.title': 'Mejora de Prompt con IA',
    'ai.suggestions.description': 'Selecciona una o más sugerencias para insertarlas en tu prompt para revisión. Luego puedes editar y enviar manualmente.',
    'ai.suggestions.apply': 'Aplicar Sugerencias',
    'ai.suggestions.clarification': 'Aclaración adicional',
    'ai.suggestions.clarification.label': 'Aclaración adicional (opcional)',
    'ai.suggestions.clarification.placeholder': 'Añade requisitos específicos o contexto...',
    'ai.suggestions.context.prompt': 'Desde entrada',
    'ai.suggestions.context.message': 'Último mensaje',
};
